var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.333,
    viewBox: "0 0 24 21.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0a5 5 0 0 0-5 5c0 2.016.7 2.579 4.488 8.063a.625.625 0 0 0 1.027 0C16.3 7.579 17 7.017 17 5a5 5 0 0 0-5-5zM.419 9.483A.664.664 0 0 0 0 10.1v10.563a.668.668 0 0 0 .917.618l5.75-2.614V8.392a8.226 8.226 0 0 1-.692-1.413zm13.189 4.342a1.958 1.958 0 0 1-3.219 0C9.717 12.846 8.2 10.692 8 10.4v8.229l8 2.7V10.4c-.2.292-1.717 2.446-2.392 3.425zm9.479-7.108-5.754 2.616v12l6.246-2.816A.706.706 0 0 0 24 17.9V7.333a.65.65 0 0 0-.913-.616z",
    style: {
      fill: "#008da9"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.f6451febd173164229f86ad3a32ea1d1.svg";
export { ForwardRef as ReactComponent };